import { User } from '@wilson/interfaces';

export class ResetUsersState {
  static readonly type = '[UsersState] ResetUsersState';
}

export class FetchAllUsersIfNeeded {
  static readonly type = '[UsersState] FetchAllUsersIfNeeded';
}

export class RefreshUsers {
  static readonly type = '[UsersState] Refresh Users';
}

export class UpdateSingleUser {
  static readonly type = '[UsersState] Update Single User';
  constructor(public user: Partial<User & { id: string }>) {}
}

export class UpdateMultipleUsers {
  static readonly type = '[UsersState] Update Single User';
  constructor(public users: Partial<User & { id: string }>[]) {}
}
